export default {"src":"/_next/static/media/Appendicitis.a93c39d8.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};